import { render, staticRenderFns } from "./myLayoutList.vue?vue&type=template&id=478b89f4&scoped=true&"
import script from "./myLayoutList.vue?vue&type=script&lang=js&"
export * from "./myLayoutList.vue?vue&type=script&lang=js&"
import style0 from "./myLayoutList.vue?vue&type=style&index=0&id=478b89f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b89f4",
  null
  
)

export default component.exports